<script setup lang="ts">
import { LazyImg, Waterfall } from 'vue-waterfall-plugin-next'
import 'vue-waterfall-plugin-next/dist/style.css'
import router from '@/router';
import { ref, reactive, onMounted } from 'vue';
import { symbolByCurrency } from '@/utils';
const props = defineProps({
	list: <any>Array,
  height:String,
  loading:Boolean,
  finished:Boolean
});


const handleClick = (id:string)=> {
  router.push(`/product-detail/${id}`)
}
</script>
<template>
	<Waterfall :list="list" :posDuration="0" :animationDelay="0" :gutter="12" :breakpoints="{
    1300:{rowPerView:5},
    1200:{rowPerView:5},
    1000:{rowPerView:4},
    800:{rowPerView:3},
    500:{rowPerView:2}
    }">
      <template #item="{ item, url, index }">
        <div
          class="cell-item"
          @click="() => handleClick(item.id)"
        >
          <img v-if="item.picUrl" :src="item.picUrl" alt="加载错误" />
          <div class="item-body">
            <div class="item-title">
              <!-- <span class="tag"><i class="icon"></i> XSTAR</span> -->
               {{ item.name }}
            </div>
            <div class="intro">{{item.introduction}}</div>
            <div class="price">{{ symbolByCurrency[item.priceSymbol] }} <span class="number-font">{{item.price / 100 || 0}}</span> <span class="text">起</span></div>
          </div>
        </div>
      </template>
    </Waterfall>
</template>

<style lang="scss" scoped>
.waterfall-list{
  background-color:transparent;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 12px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba($color: #29c1cc, $alpha: 0.58);
    border-radius: 12px;
    width: 4px;
    height: 14px;
  }
  &:empty{
    display: none;
  }
}
.cell-item {
    width: 100%;
    // margin-bottom: 18px;
    background: #ffffff;
    padding: 8px 8px 0 8px;
    border-radius: 12px 12px 12px 12px;
    overflow: hidden;
    box-sizing: border-box;
    img {
      // border-radius: 12px 12px 0 0;
      width: 100%;
      height: 154px;
      display: block;
      border-radius: 10px;
      object-fit: cover;
    }
    .item-body {
      // border: 1px solid #F0F0F0;
      padding: 12px 0;
      .item-title {
        position: relative;
        font-size: 14px;
        color: #333333;
        line-height: 15px;
        font-weight: bold;
        line-height: 1.6;
        overflow: hidden;
        text-overflow: ellipsis;
        /* 将对象作为弹性伸缩盒子模型显示 */
        display: -webkit-box;
        /* 限制在一个块元素显示的文本的行数 */
        /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
        -webkit-line-clamp: 2;
        /* 设置或检索伸缩盒对象的子元素的排列方式 */
        -webkit-box-orient: vertical;
        .tag {
          display: inline-flex;
          padding: 3px 4px;
          font-size: 8px;
          border-radius: 4px;
          color: #fff;
          top: 3px;
          border-radius: 4px;
          background:  linear-gradient(224deg, #EAADFF 0%, #EFDBFF 44.6%, #76D6FF 98.01%);
          justify-content: flex-start;
          align-items: center;
          gap: 2px;
          .icon{
            display: inline-block;
            width: 16px;
            height: 16px;
            background: url(../assets/xstar.png);
            background-size: contain;
            background-repeat: no-repeat;
          }
        }
      }
      .intro{
        font-size: 12px;
        color: #9C9CAA;
        line-height: 1.6;
      }
      .price{
        font-size: 12px;
        color: #FF3456;
        font-weight: 700;
        margin-top: 8px;
        .number-font{
          font-size: 18px;
        }
        .text{
          color: #000;
        }
      }
    }
  }
</style>